module.exports = __webpack_public_path__ + "img/img42.60729cf0.jpg";